

const routeGuards = store => {

	const auth = store.getters.getAuthService

	const checkRole = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth) {
			switch (auth.currentRole.nama_role) {
				case 'Penduduk':
					next({ name: 'HomePenduduk' })
					break

				case 'Kepala Dusun':
					next({ name: 'HomeKepalaDusun' })
					break

				case 'Operator Desa':
					next({ name: 'HomeOperatorDesa' })
					break

				case 'Kepala Desa':
					next({ name: 'HomeKepalaDesa' })
					break

				case 'Operator Kecamatan':
					next({ name: 'HomeOperatorKecamatan' })
					break

				case 'Operator Dukcapil':
					next({ name: 'HomeOperatorDukcapil' })
					break

				case 'Operator Dukcapil Kecamatan':
					next({ name: 'HomeOperatorDukcapil' })
					break

				case 'Admin Laksita':
					next({ name: 'HomeAdmin' })
					break

				case 'Admin Jembrana':
					next({ name: 'HomeAdmin' })
					break

				case 'UMKM':
					next({ name: 'HomeUmkm' })
					break
                
				case 'Jasa Antar':
					next({ name: 'HomeJasaAntar' })
					break
        
				case 'Rumah Sakit':
					next({ name: 'HomeRumahSakit' })
					break
			}
		} else {
			// jangan localStorage.clear(), karena siapa tau dia centang simpan data login
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: 'Login' })
		}
	}
	const authGuard = (to, from, next) => {
		if (auth.isAuthenticated) {
			next()
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
	const pendudukGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth && auth.currentRole.nama_role === 'Penduduk') {
			next()
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
	const kepalaDusunGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth && auth.currentRole.nama_role === 'Kepala Dusun') {
			next()
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
	const desaGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth) {
			if (auth.currentRole.nama_role === 'Operator Desa' || auth.currentRole.nama_role === 'Kepala Desa') {
				next()
			} else {
				localStorage.removeItem('authService')
				localStorage.removeItem('fcmToken')
				next({ name: '403' })
			}
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
	const kepalaDesaGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth && auth.currentRole.nama_role === 'Kepala Desa') {
			next()
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
	const kecamatanGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth && auth.currentRole.nama_role === 'Operator Kecamatan') {
			next()
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
	const dukcapilGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth) {
			if (auth.currentRole.nama_role === 'Operator Dukcapil' || auth.currentRole.nama_role === 'Operator Dukcapil Kecamatan') {
				next()
			} else {
				localStorage.removeItem('authService')
				localStorage.removeItem('fcmToken')
				next({ name: '403' })
			}
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
	const adminGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth) {
			if (auth.currentRole.nama_role === 'Admin Laksita' || auth.currentRole.nama_role === 'Admin Jembrana') {
				next()
			} else {
				localStorage.removeItem('authService')
				localStorage.removeItem('fcmToken')
				next({ name: '403' })
			}
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
	const adminAndDukcapilGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth) {
			if (auth.currentRole.nama_role === 'Admin Laksita' || auth.currentRole.nama_role === 'Admin Jembrana' ||
				auth.currentRole.nama_role === 'Operator Dukcapil' || auth.currentRole.nama_role === 'Operator Dukcapil Kecamatan') {
				next()
			} else {
				localStorage.removeItem('authService')
				localStorage.removeItem('fcmToken')
				next({ name: '403' })
			}
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
	const desaAndAdminGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth) {
			if (auth.currentRole.nama_role === 'Admin Laksita' || auth.currentRole.nama_role === 'Admin Jembrana' ||
				auth.currentRole.nama_role === 'Operator Desa' || auth.currentRole.nama_role === 'Kepala Desa') {
				next()
			} else {
				localStorage.removeItem('authService')
				localStorage.removeItem('fcmToken')
				next({ name: '403' })
			}
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
	const operatorGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth) {
			if (auth.currentRole.nama_role != 'Penduduk') {
				next()
			} else {
				localStorage.removeItem('authService')
				localStorage.removeItem('fcmToken')
				next({ name: '403' })
			}
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
	const publicGuard = (to, from, next) => {
		if (!auth.isAuthenticated && !sessionStorage.auth) {
			next()
		} else {
      if (!auth.isAuthenticated && sessionStorage.auth) {
        sessionStorage.clear()
      }
			// localStoragenya udah kosong, tapi store.getAuthService nya masih return yg ada di localStorage (masih login)
			// kayaknya itu cuma kepanggil sekali aja (diatas), soalnya pas di console.log disana, cuma sekali keluar
			if (!localStorage.authService) {
				window.location = ''
			} else {
				next({ name: 'Home' })
			}
		}
	}
	const umkmGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth) {
			if (auth.currentRole.nama_role === 'UMKM') {
				next()
			} else {
				localStorage.removeItem('authService')
				localStorage.removeItem('fcmToken')
				next({ name: '403' })
			}
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
	const jasaAntarGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth) {
			if (auth.currentRole.nama_role === 'Jasa Antar') {
				next()
			} else {
				localStorage.removeItem('authService')
				localStorage.removeItem('fcmToken')
				next({ name: '403' })
			}
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
	const rumahSakitGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth && auth.currentRole.nama_role === 'Rumah Sakit') {
			next()
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}
  const desaAndRsGuard = (to, from, next) => {
		if (auth.isAuthenticated && sessionStorage.auth) {
			if (['Operator Desa', 'Kepala Desa', 'Rumah Sakit'].includes(auth.currentRole.nama_role)) {
				next()
			} else {
				localStorage.removeItem('authService')
				localStorage.removeItem('fcmToken')
				next({ name: '403' })
			}
		} else {
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
			next({ name: '403' })
		}
	}

	return {
		authGuard,
		checkRole,
		pendudukGuard,
		kepalaDusunGuard,
		desaGuard,
		kepalaDesaGuard,
		kecamatanGuard,
		dukcapilGuard,
		adminGuard,
		adminAndDukcapilGuard,
    desaAndAdminGuard,
		publicGuard,
		operatorGuard,
    umkmGuard,
    jasaAntarGuard,
    rumahSakitGuard,
    desaAndRsGuard
	}

}

export default routeGuards